"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "phone icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Phone Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M18.682 29.318a35.016 35.016 0 008.55 6.29l4.888-4.886a2.221 2.221 0 012.317-.51 26.354 26.354 0 007.214 1.385 2.3 2.3 0 011.573.68 2.3 2.3 0 01.679 1.601L44 41.774A2.184 2.184 0 0141.77 44c-9.472-.362-18.917-4.217-26.235-11.535C8.217 25.147 4.362 15.702 4 6.23A2.184 2.184 0 016.226 4l7.896.097a2.304 2.304 0 011.602.68 2.3 2.3 0 01.679 1.572c.12 2.438.582 4.867 1.384 7.214a2.22 2.22 0 01-.51 2.317l-4.884 4.888a35.016 35.016 0 006.29 8.55z"
  }));
};

var _default = SvgIconPhone;
exports.default = _default;